const __WEBPACK_NAMESPACE_OBJECT__ = {parse: () => {throw new Error("parse5 is not bundled for the browser; parseHTMLBody uses the native DOMParser there.")}};